import axios from 'axios';

export default class ManagerPage {
  constructor(element, optionalContainer) {
    this.passedElement = element;
    this.activeRegion;
    this.activeAssetClass;
    this.searchQuery;
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.getElements();
      this.addEventListeners();
    }
  }

  getElements = () => {
    this.filterMenus = this.passedElement.querySelectorAll(".filter-menu");
    this.regionFilters = this.passedElement.querySelectorAll(".manager-ui__region");
    this.assetClassFilters = this.passedElement.querySelectorAll(".manager-ui__asset");
    this.managers = this.passedElement.querySelectorAll(".manager");
    this.searchField = this.passedElement.querySelector("#manager-search");
    this.clearSearchIcon = this.passedElement.querySelector(".manager-ui__search-clear");
    this.searchIcon = this.passedElement.querySelector(".manager-ui__search-icon");
    this.noResults = this.passedElement.querySelector(".manager-ui__result-text");
    this.noResultSearch = this.noResults.querySelector(".js-search-phrase");
    this.noResultsTerm = this.noResults.querySelector(".js-search-term");
  }

  checkNoResults = () => {
    const results = [...this.managers].find(elm => !elm.classList.contains('hidden'));
    if ( results ) {
      if ( !this.noResults.classList.contains('hidden') ) this.noResults.classList.add('hidden');
    } else {
      this.noResults.classList.remove('hidden');
      if ( this.searchQuery ) {
        this.noResultsTerm.innerText = this.searchQuery;
        this.noResultSearch.classList.remove('hidden');
      }else{
        this.noResultSearch.classList.add('hidden');
      }
    }
    console.log(results);
  }

  filterManagers = () => {
    this.managers.forEach(manager => {
      if (!this.activeRegion && !this.activeAssetClass) {
        manager.classList.remove('hidden'); 
        return null;
      }
      const region = manager.dataset.region?.toLowerCase().split(",");
      const asset = manager.dataset.assetclass?.toLowerCase().split(",");

      manager.classList.add('hidden');

      if (this.activeRegion && this.activeAssetClass) {
        if ( region.includes(this.activeRegion) && asset.includes(this.activeAssetClass) ) manager.classList.remove('hidden');
      } else {
        if ( this.activeRegion &&  region.includes(this.activeRegion) ) manager.classList.remove('hidden');
        if ( this.activeAssetClass && asset.includes(this.activeAssetClass) ) manager.classList.remove('hidden');
      }

    });
  }

  searchManagers = () => {
    if ( this.searchQuery ) {
      this.managers.forEach(manager => {
        const name = manager.querySelector('.manager__name').innerText.toLowerCase();
        const description = manager.querySelectorAll('.manager__inner p')[0].innerText.toLowerCase();

        name.includes(this.searchQuery) || description.includes(this.searchQuery) 
        ? manager.classList.remove('hidden')
        : manager.classList.add('hidden');
      });
    }
  }

  setActiveRegion = (region) => {
    this.regionFilters.forEach(elm=>{
      if (elm.dataset.slug === region.dataset.slug && !elm.classList.contains('active')) {
        elm.classList.add("active");
      } else {
        elm.classList.remove("active");
      }
    });
    this.activeRegion === region.dataset.slug
    ? this.activeRegion = undefined
    : this.activeRegion = region.dataset.slug;
    this.filterManagers();
  }

  setActiveAssetClass = (asset) => {
    this.assetClassFilters.forEach(elm=>{
      if (elm.dataset.slug === asset.dataset.slug && !elm.classList.contains('active')) {
        elm.classList.add("active");
      } else {
        elm.classList.remove("active");
      }
    });
    this.activeAssetClass === asset.dataset.slug
    ? this.activeAssetClass = undefined
    : this.activeAssetClass = asset.dataset.slug;
    this.filterManagers();
  }

  clearFilters = () => {
    this.activeRegion = null;
    this.activeAssetClass = null;
    this.assetClassFilters.forEach(elm=>elm.classList.remove('active'));
    this.regionFilters.forEach(elm=>elm.classList.remove('active'));
  }

  clearSearch = () => {
    this.searchQuery = undefined;
    this.searchField.value = '';
    this.clearSearchIcon.classList.add('hidden');
    this.searchIcon.classList.remove('hidden');
  }

  toggleClearSearch = () => {
    if (this.searchQuery) {
      this.clearSearchIcon.classList.remove('hidden');
      this.searchIcon.classList.add('hidden');
    } else {
      this.clearSearchIcon.classList.add('hidden');
      this.searchIcon.classList.remove('hidden');
    }
  }

  addEventListeners = () => {

    this.regionFilters.forEach((region) => {
      const handleRegionClick = (e) => {
        e.preventDefault();
        this.clearSearch();
        this.setActiveRegion(region);
        this.checkNoResults();
      };
    
      region.addEventListener('click', handleRegionClick);
      region.addEventListener('ontouchstart', handleRegionClick);
    });

    this.assetClassFilters.forEach((asset) => {

      const handleRegionClick = (e) => {
        e.preventDefault();
        this.clearSearch();
        this.setActiveAssetClass(asset);
        this.checkNoResults();
      }

      asset.addEventListener('click', handleRegionClick);
      asset.addEventListener('ontouchstart', handleRegionClick);
    });

    this.searchField.addEventListener('input', () => {
      this.searchQuery = this.searchField.value.toLowerCase();
      this.toggleClearSearch();
      this.clearFilters();
      this.searchManagers();
      this.checkNoResults();
    });

    this.searchField.addEventListener('change', () => {
      this.clearFilters();
      this.searchManagers();
      this.checkNoResults();
    });

    ['click','ontouchstart'].forEach((evt) => {
      this.clearSearchIcon.addEventListener(evt, () => {
        this.clearSearch();
        this.managers.forEach(manager => manager.classList.remove('hidden'));
        this.checkNoResults();
      });
    });

  }

}
